import CloseIcon from 'assets/images/rectangle/close.svg'
import classNames from 'classnames'
import FormikInput from 'components/formikFields/input'
import DotsLoading from 'components/loadings/dotsLoading'
import { Form, Formik } from 'formik'
import useSetInitTransaction from 'modules/easyPay/init/hooks/useSetInitTransaction'
import { useState } from 'react'
import Num2persian from 'utilities/helper/num2Persian'
import { Schema } from './utilities'
import useSetTransaction from '../hooks/useSetTransaction'
import { toast } from 'react-toastify'
import { ISelectedBank } from 'utilities/hooks/useIsDefaultGateway'
interface IIncreaseProps {
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export default function Increase({ setIsOpen }: IIncreaseProps) {
    const [isSelected, setIsSelected] = useState<ISelectedBank>({
        saderat: false,
        parsian: true,
    })
    const profile = JSON.parse(localStorage.getItem('profile')!)
    const { data, isLoading } = useSetInitTransaction(profile.id)
    const { mutate } = useSetTransaction()
    return (
        <div className=" w-full">
            <div className=" w-full flex justify-between items-center px-3 mb-3">
                <div></div>
                <div>افزایش موجودی</div>
                <img
                    src={CloseIcon}
                    alt="close"
                    onClick={() => setIsOpen(false)}
                />
            </div>
            <hr />
            <p className=" mt-3 text-center px-1">
                مبلغ مورد نظر خود را برای افزایش موجودی وارد نمایید.
            </p>
            <Formik
                initialValues={{ amount: '' }}
                validationSchema={Schema}
                onSubmit={async (values) => {
                    if (Number(values.amount) < 5000) {
                        toast.error(
                            'مقدار کیف پول باید بیشتر از 5000 تومان باشد'
                        )
                    } else {
                        if (!isLoading && data) {
                            mutate({
                                // ctx_id: data?.receivers[0].id,
                                // amount: Number(values.amount),
                                // gateway: Number(isSelected.saderat ? 5 : 9),
                                clientType: 'pwa',
                                gateway: {
                                    uniqueCode: 'HAM_IPG',
                                },
                                amount: Number(values.amount)
                            })
                        }
                    }
                }}
            >
                {({ values }) => (
                    <Form>
                        <div className="mx-3 mt-3">
                            <FormikInput
                                type="number"
                                label="مبلغ"
                                name="amount"
                                placeholder="مبلغ را وارد کنید"
                                secondaryTitle="تومان"
                                min={0}
                            />
                            {values.amount !== '' && (
                                <span className=" text-xs">
                                    {Num2persian(values.amount.toString())}{' '}
                                    تومان
                                </span>
                            )}
                        </div>
                        {!isLoading && data ? (
                            <div className=" w-full items-center text-center mb-4 mt-20">
                                <div className="flex justify-center h-20 w-1/2 mr-[25%]">
                                    <img
                                        src={
                                            data?.gateways &&
                                            data?.gateways[0]?.img_url
                                        }
                                        hidden={!data?.gateways[0]?.is_active}
                                        alt="bank"
                                        className={classNames(
                                            'mx-2 cursor-pointer',
                                            !isSelected.saderat
                                                ? ' shadow-[rgba(50,50,93,0.25)_0px_6px_12px_-2px,_rgba(0,0,0,0.3)_0px_3px_7px_-3px] rounded-md'
                                                : 'border-2 border-green-1 rounded-md'
                                        )}
                                        onClick={() =>
                                            setIsSelected({
                                                saderat: false,
                                                parsian: true,
                                            })
                                        }
                                    />
                                    <img
                                        src={
                                            data?.gateways &&
                                            data?.gateways[1]?.img_url
                                        }
                                        hidden={!data?.gateways[1]?.is_active}
                                        alt="bank"
                                        className={classNames(
                                            'mx-2 cursor-pointer',
                                            !isSelected.parsian
                                                ? ' shadow-[rgba(50,50,93,0.25)_0px_6px_12px_-2px,_rgba(0,0,0,0.3)_0px_3px_7px_-3px] rounded-md'
                                                : 'border-2 border-green-1 rounded-md'
                                        )}
                                        onClick={() =>
                                            setIsSelected({
                                                saderat: true,
                                                parsian: false,
                                            })
                                        }
                                    />
                                </div>
                            </div>
                        ) : (
                            <DotsLoading />
                        )}
                        <div className=" mx-3">
                            <button
                                type="submit"
                                className=" w-full bg-green-1 text-white rounded-2xl py-3"
                            >
                                تایید و ادامه
                            </button>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    )
}
